// pages/ConfirmEmail.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { supabase } from '../../services/supabaseClient/supabaseClient';
import { setUser } from '../../redux/authSlice';

const ConfirmEmail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const confirmUser = async () => {
      const { data } = await supabase.auth.getSession();
      const session = data?.session;

      if (session?.user) {
        dispatch(setUser(session.user));
        // ✅ Trigger custom logic or confirmation message here
        // e.g., show toast "Account confirmed!"
        navigate('/dashboard');
      } else {
        // Try to recover session from URL
        const { session } = await supabase.auth.getSessionFromUrl();
        if (session) {
          dispatch(setUser(session.user));
          navigate('/dashboard');
        }
      }
    };

    confirmUser();
  }, [dispatch, navigate]);

  return <p>Confirming your account...</p>;
};

export default ConfirmEmail;
